import { LogLevel } from '../logger/log-levels.enum';
import { EventMessage } from '../models/log-message.model';
import { AbstractTransporterDecorator } from './abstract-transporter-decorator';
import { TransporterConfig } from './transporter-config.model';
import { CapturedPayload, TransportTemplate } from './transporter-template.model';

/**
 * Default ConsoleTransporter template
 */
export const defaultConsoleTransporterTemplate = <T extends EventMessage>(p: CapturedPayload) => p.payload as T;

/**
 * Console transporter
 */
export class ConsoleTransporter<T extends EventMessage = EventMessage> extends AbstractTransporterDecorator<T> {
  /**
   *
   * @param template optional if not given, using default (no template, as message comes is written)
   */
  constructor(template?: TransportTemplate<T>, config?: TransporterConfig) {
    super(template || defaultConsoleTransporterTemplate, config);
  }

  /**
   * writes payload in console
   */
  doWrite(payload: T, level: LogLevel): void {
    switch (level) {
      case LogLevel.Info:
        return console.info(payload);
      case LogLevel.Debug:
        return console.debug(payload);
      case LogLevel.Warn:
        return console.warn(payload);
      case LogLevel.Error:
        return console.error(payload);
    }
  }
}
